/*
 * Copyright (c) Vaisala Oyj. All rights reserved.
 */

import { QuantityMapping } from '../units/unitTypes';
import {
  ParameterName,
  getValidityState,
  ClosedSystemCalculatorResult,
  MethodType,
  OpenSystemCalculatorResult,
  FreeEvaporationCalculatorResult,
} from './calculatorTypes';

const paramConfig = require('./parameterConfig_NEW.json');
const unitPresets = require('../units/unitPresets.json');

////////////////////////////////////////////////////
// PARAMETERS
////////////////////////////////////////////////////

export const getDefaultParameters = (method: MethodType) => {
  let defaults: any;
  let config: any;
  switch (method) {
    case 'closedSystem':
      defaults = new ClosedSystemCalculatorResult();
      config = paramConfig.methods[0];
      break;
    case 'openSystem':
      defaults = new OpenSystemCalculatorResult();
      config = paramConfig.methods[1];
      break;
    case 'freeEvaporation':
      defaults = new FreeEvaporationCalculatorResult();
      config = paramConfig.methods[2];
      break;
  }
  defaults.validityState = getValidityState();

  config.cards.forEach((card: any, i: number) => {
    card.inputs.concat(card.outputs).forEach((row: any) => {
      //console.log(`${paramNameForRow(row)}${row.phase === 0 || row.phase >= 1 ? row.phase : ''}`, row.default);
      defaults.calculatorData.cards[i][`${paramNameForRow(row)}${row.phase === 0 || row.phase >= 1 ? row.phase : ''}`] = row.default;
    });
  });

  return defaults;
};

export const paramNameForRow = (row: any) => row.labelKey.split('.')[1] as ParameterName;

// const parseModifier = (modifierConfig: any) => {
//   switch (modifierConfig.type) {
//     case 'numeric':
//       return modifierConfig.default ?? 0;
//   }
//   throw new TypeError('Invalid config: cannot parse type ' + modifierConfig.type);
// };

////////////////////////////////////////////////////
// UNITS
////////////////////////////////////////////////////

export const getQuantities = () => {
  let config: QuantityMapping[] = [];
  paramConfig.methods.forEach((method: any) => {
    method.cards.forEach((card: any) => {
      const rows = card.inputs.concat(card.outputs);
      config = config.concat(
        rows.map((row: any) => ({
          parameter: paramNameForRow(row),
          quantity: row.quantity,
        }))
      );
    });
  });
  return config;
};

export const getUnitPresets = () => {
  return unitPresets.presets.map((preset: any) => ({
    mode: preset.mode,
    selections: Object.entries(preset.selections).map((sel) => {
      const [key, value] = sel;
      return { parameter: key, unitIndex: value };
    }),
  }));
};
